<template>
    <div id="main">
        <Header />
        <div class="main-body">
            <router-view />
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
    name: "Main",
    components: {
        Header,
        Footer,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
    .main-body{
        padding-top: 92px;
        min-height: calc(100vh - 424px);
        box-sizing: border-box;
    }
</style>
